import { gradiantBackground } from 'app/Private/Clients/Detail/InfoTab/components/AiSummaryPanel/AiSummaryPanel.styles';
import { Panel } from 'components/Panel';

type AiSummaryBasePanelProps = React.PropsWithChildren<React.ComponentProps<typeof Panel>>;

export const AiSummaryBasePanel = ({ children, ...panelProps }: AiSummaryBasePanelProps) => {
  return (
    <Panel
      className={gradiantBackground}
      style={{ borderColor: '#d9b7ff' }}
      w="100%"
      h="100%"
      {...panelProps}
    >
      {children}
    </Panel>
  );
};
